'use client';

import { type JSX } from 'react';

import { Tooltip, cn, getAccessibleFocusStyles } from '@videoblocks/design-system';
import { InformationCircleInverted } from '@videoblocks/design-system/icons';

interface InfoButtonTooltipProps {
    title: string;
    label: string;
}

/**
 * Info icon button that reveals a tooltip on hover/focus. Rendered as a real button (not a disabled
 * control) so it stays keyboard-focusable even when it sits beside a disabled field.
 */
export function InfoButtonTooltip({ title, label }: InfoButtonTooltipProps): JSX.Element {
    return (
        <Tooltip
            title={title}
            variant="light"
            className="max-w-60 text-center"
            trigger={
                <button
                    type="button"
                    aria-label={`Why is ${label} disabled?`}
                    className={cn('flex', getAccessibleFocusStyles())}
                >
                    <InformationCircleInverted className="w-4 h-4" />
                </button>
            }
        />
    );
}
